import { PET_INSURANCE_APIS } from "@/api_framework/api_config";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useAPIUtils } from "../../useAPIUtils";
import { useConfiguration } from "../../useConfiguration";

AxiosCurlirize(axios, () => {});

export const usePetInsuranceSendFormAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (formId: string, mobileNumber: string): Promise<boolean> => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response = await axios.post(PET_INSURANCE_APIS?.SEND_FORM_URL?.baseURL ?? "", null, {
          params: { form_id: formId, mobile: mobileNumber },
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        });

        if (response.data?.status === false) {
          toast.error(response.data?.message ?? "Failed to send form");
          return false;
        }
        toast.success("Form sent successfully");
        return true;
      } catch (error) {
        const axiosError = error as AxiosError;
        captureError(axiosError);
        sendCurl((axiosError.config as any)?.curlCommand);
        toast.error("Failed to send form");
        return false;
      }
    },
    [captureError, configuration.localStorage.ACCESS_TOKEN.key, sendCurl],
  );

  return execute;
};
